import { useEffect } from 'react';
import { newPageTrigger } from 'LivePerson';
import { PearlConnectFlowLoaderStyled } from './PearlConnectFlowLoader.styled';
import { PearlConnectSpinnerRing } from './PearlConnectSpinnerRing.styled';

const PearlConnectFlowLoader = () => {
    useEffect(() => {
        newPageTrigger(window.location.href);
    }, [window.location.href]);

    return (
        <PearlConnectFlowLoaderStyled id="site-loader">
            <PearlConnectSpinnerRing role="status" aria-live="polite" aria-label="Loading" />
        </PearlConnectFlowLoaderStyled>
    );
};

export { PearlConnectFlowLoader };
